import { Dialog, DialogContent, DialogTrigger } from '@/components/atoms/Dialog';
import { NewsBadge } from '@/pages/NewsBriefing/_components/NewsHeader';
import { convertAsteriskToNormal } from '@/utils/parser';
import { DashboardCard } from '../card';
import { NewsBriefingSwiper } from './NewsBriefingSwiper';
import { useNewsBriefing } from '@/pages/NewsBriefing/_context/NewsContext';
import { NEWS_BRIEFING_TITLE_BUTTON_CLASS_NAME } from './news-briefing-styles';
import { useMembershipPreviewMode } from '@/components/membership/MembershipContentLock';

const preventNewsDialogOutsideClose = (event: Event) => {
  event.preventDefault();
};

const NewsBriefing = () => {
  const isPreviewMode = useMembershipPreviewMode();
  const { data } = useNewsBriefing();
  const ecommerceTopicList = data?.ecommerceTopicList || [];

  return (
    <DashboardCard>
      <div className="flex items-center gap-3">
        <span className="text-gr-900 Body1S16">뉴스 브리핑</span>
        <NewsBadge />
      </div>
      <div className="space-y-2">
        {ecommerceTopicList.map((item, index) => (
          <div key={index} className="flex flex-col items-start gap-2">
            <Dialog>
              <DialogTrigger asChild>
                <button
                  className={NEWS_BRIEFING_TITLE_BUTTON_CLASS_NAME}
                  data-membership-preview-interactive={isPreviewMode ? 'true' : undefined}
                >
                  {convertAsteriskToNormal(item.title ?? '')}
                </button>
              </DialogTrigger>
              <DialogContent
                className="min-w-[580px] "
                data-membership-preview-interactive={isPreviewMode ? 'true' : undefined}
                onInteractOutside={preventNewsDialogOutsideClose}
              >
                <NewsBriefingSwiper defaultIndex={index} />
              </DialogContent>
            </Dialog>
            {index !== ecommerceTopicList.length - 1 && <div className="h-px w-full bg-gr-200" />}
          </div>
        ))}
      </div>
    </DashboardCard>
  );
};

export default NewsBriefing;
